// useMatomoTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useMatomoTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window._paq) {
      // Aktualisiere die URL für Matomo
      window._paq.push(['setCustomUrl', window.location.href]);
      // Sende einen Page-View
      window._paq.push(['trackPageView']);
    }
  }, [location]);
};

export default useMatomoTracking;